import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Home.vue';
import Login from '../views/Login.vue';
import store from '../store';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    children: [
      {
        path: 'student',
        component: () => import(/* webpackChunkName: "student" */ '@/components/StudentCursusList.vue'),
      },
      {
        path: 'teacher',
        component: () => import(/* webpackChunkName: "teacher" */ '@/components/TeacherCursusList.vue'),
      },
    ],
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

// eslint-disable-next-line consistent-return
router.beforeEach(async (to, from, next) => {
  if (store.getters.isAuth !== (to.name === 'Login')) {
    if (to.path === '/') {
      const groups = store.getters.user.groups;
      if (groups.includes('ENS')) return next('teacher');
      if (groups.includes('ETU')) return next('student');
    }
    return next();
  }
  if (store.getters.isAuth) return next('/');
  next('/login');
});

export default router;
